import React from "react";

const overlayStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 2,
};

const contentStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  fontSize: "24px",
  color: "white",
  transform: "translate(-50%,-50%)",
  msTransform: "translate(-50%,-50%)",
};

export const InlineLoading = ({
  isLoading = false,
  textInfo = "Loading...",
}) => {
  return (
    <span style={{ visibility: `${isLoading ? "visible" : "hidden"}` }}>
      <i className="fas fa-spinner fa-pulse"></i> {textInfo}
    </span>
  );
};

export const BlockLoading = ({ loading = false, text = "Loading..." }) => {
  return (
    <div style={{ ...overlayStyle, display: loading ? "block" : "none" }}>
      <span style={contentStyle}>
        <i className="fas fa-spinner fa-pulse mr-2"></i>
        {text}
      </span>
    </div>
  );
};
